import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input ": {
    "&::placeholder": {
      color: "textColor.50",
      opacity: "0.4",
    },
    color: theme.palette.text.main,
    borderRadius: "10px !important",
  },

  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.origin.main,
    },
  },
  "&::hover": {
    borderColor: theme.palette.origin.main,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "5px",
    borderColor: theme.palette.text.main,
    "&:hover": {
      borderColor: theme.palette.origin.main,
    },
  },
  "& .MuiFilledInput-root": {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&::hover": {
      borderColor: theme.palette.origin.main,
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      borderColor: theme.palette.origin.main,
    },
  },
}))

export const SelectStyled = styled(Select)(({ theme }) => ({
  color: theme.palette.origin.main,
  "& .MuiInputBase-input": {
    color: theme.palette.origin.main,
    borderRadius: "10px !important",
  },
  "& .MuiOutlinedInput-root": {
    color: 'red',
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.origin.main,
    },
  },
  "&::hover": {
    borderColor: theme.palette.origin.main,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "5px",
    color: theme.palette.origin.main,
    borderColor: theme.palette.text.main,
    "&:hover": {
      borderColor: theme.palette.origin.main,
    },
  },
}))

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.text.main,
  '&.MuiMenuItem-root': {
    color: theme.palette.text.main,
  },
  '&:hover': {
    color: theme.palette.text.main,
  },
  '&.MuiSelect-selected': {
    color: theme.palette.text.main,
  },
}));